import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { ApiUsuarioService } from './api-usuario.service';
import { UtilsService } from './utils.service';

interface Credencial {
  trials: { product: number; expired: boolean }[];
  products: { licenses: number; product: number }[];
}
type Status = 'TRIALLING' | 'ACQUIRED' | 'UNACQUIRED' | 'TRIALEXPIRED';

@Injectable({
  providedIn: 'root',
})
export class TrialService {
  private readonly apiUsuario = inject(ApiUsuarioService);
  private readonly router = inject(Router);
  private readonly utilsService = inject(UtilsService);

  public showCTA(produtoId: number) {
    if (!this.isFeatureSaudeModuleEnabled()) {
      return false;
    }

    const status = this.getStatus(produtoId);

    return status === 'TRIALEXPIRED' || status === 'UNACQUIRED';
  }

  public getStatus(produtoId: number): Status {
    const credencial = this.apiUsuario.getCredenciais() as Credencial;
    const produto = credencial.products?.find((p) => p.product === produtoId);

    if (produto && produto?.licenses > 0) return 'ACQUIRED';

    const trial = credencial.trials?.find((c) => c.product === produtoId);

    if (!trial) return 'UNACQUIRED';

    return trial.expired ? 'TRIALEXPIRED' : 'TRIALLING';
  }

  public async iniciarTeste() {
    const result: any = await this.apiUsuario.ativarTrial({ productId: 11, days: 14 })

    this.utilsService.alertCustom({
      alertType: result.isError ? 'ERROR' : 'SUCCESS',
      txt: result.message || 'Período de teste iniciado'
    });

    if (!result.isError) {
      window.location.reload()
    }
  }

  public openContratar() {
    this.router.navigate(['meu-plano'], {
      state: { openContratarSaudeDialog: true },
    });
  }

  public isFeatureSaudeModuleEnabled(): boolean {
    // TODO: Módulo liberado para o público geral em 2026-02-25.
    // As travas podem ser removidas na sequência.
    return true; 
  }
}

